/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![WidgetsIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABGklEQVR4nN2US07DQAyGZ8WSIxRRzgKq6PhBJMtWuAXPIxB6Tgq9QtgUGWgUpWnSGSEBteRVPvm3M/Yfwl8OZj0DsodIehejTAZhETlC1mcgfUW29SaBdYlslX9v85H1AkjfG46sBrLFbHZ93CvgRdqFe7LasF4EWVf9nK5cfEvgu9OdAsC6bFiyxSBLVs+LctqdYD2WIYRwWZQnXmCM9bfJEgCy231YZL3JFNDHPbqvfdKsN5gX5XTsF/kbJW8RkD21V3Roi3pX9esOrOpOAjvuwIt4p+1pPm/hys7DT0aMMvFLRtZ7ADkNvxaSYBWSaCvJVoEJbBPdbraS7C2HTT60VPaABGDEKpDtJYfNsgpMYLOsQhJt5X/HByONY9recBIrAAAAAElFTkSuQmCC)
 */
export const WidgetsIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M18.45 1.85a3 3 0 0 0-4.1 1.1l-1.5 2.6a3 3 0 0 0 1.1 4.1l2.6 1.5a3 3 0 0 0 4.1-1.1l1.5-2.6a3 3 0 0 0-1.1-4.1l-2.6-1.5ZM5 2a3 3 0 0 0-3 3v3a3 3 0 0 0 3 3h3a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H5ZM5 13a3 3 0 0 0-3 3v3a3 3 0 0 0 3 3h3a3 3 0 0 0 3-3v-3a3 3 0 0 0-3-3H5ZM13 16a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3h-3a3 3 0 0 1-3-3v-3Z"
        className={colorClass}
      />
    </svg>
  );
};
